// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"14e5e3a6","323":"4cb549af","387":"07847db4","393":"4d6c4646","536":"a3767087","651":"f04cd33c","720":"733ab768","747":"51fb62d1","910":"fd20f429"}[chunkId] + ".chunk.js";
};